package com.ijoin.data.storage

import com.ijoin.data.model.Ticket

actual class TicketCache {
    private var cachedTickets: List<Ticket> = emptyList()

    actual fun saveTickets(tickets: List<Ticket>) {
        cachedTickets = tickets
    }

    actual fun getTickets(): List<Ticket> = cachedTickets

    actual fun clear() {
        cachedTickets = emptyList()
    }
}
